import { Fragment, useEffect, useState } from 'react';
import './App.css';
import { mapsApiEndpoint, mapsApiKey } from './constants/maps.constants';
import { blobToBase64 } from './helpers/file-handling.helpers';
import { AddressSlide } from './slides/address/address.slide';
import { BillSlide } from './slides/bill/bill.component';
import { ConsumptionHoursSlide } from './slides/consumption-hours/consumption-hours.component';
import { ContactSlide } from './slides/contact/contact.component';
import { RoofAngleOrientationSlide } from './slides/roof-angle-orientation/roof-angle-orientation.component';
import { RoofAreaSlide } from './slides/roof-area/roof-area.component';

function App() {
  // State
  const [step, setStep] = useState(0);
  const [formState, setFormState] = useState({
    address: {
      text: "",
      latitude: 39.6108206,
      longitude: -0.3185614
    },
    roof: {
      area: {
        value: 0
      },
      angleOrientation: {
        orientation: "N",
        angle: 0
      }
    },
    bill: {
      consumption: 0,
      url: ""
    },
    hours: {
      value: "RE"
    }
  });
  const [firstLoad, setFirstLoad] = useState(false);
  const [stepsConfirmations, setStepsConfirmations] = useState([
    false, // Address
    false, // Roof Area
    false, // Roof data
    false, // Bill
    false, // Consumption
  ]);
  // const [completed, setCompleted] = useState(false);
  const [billFile, setBillFile] = useState<File | null>(null);
  const [roofPolygon, setRoofPolygon] = useState<google.maps.Polygon | null>(null);

  // Constants
  const bottomNavigation = [
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 700 700">
      <path fill="#FFFFFF" d="m514.08,199.36c-30.24-60.48-87.92-98-154.56-101.36h-19.04c-66.64,2.8-124.32,40.88-154.56,101.36-31.36,62.72-26.32,133.84,12.88,190.96l141.68,206.64c2.24,2.8,5.6,5.04,8.96,5.04s7.28-1.68,8.96-5.04l142.8-206.64c39.2-57.12,44.24-128.24,12.88-190.96h0Zm-31.36,178.08l-132.72,193.76-132.72-193.76c-34.72-50.4-38.64-113.12-11.2-168,26.32-53.2,76.72-86.24,135.52-89.04h16.8c58.8,2.8,109.2,35.84,135.52,89.04,27.44,54.88,23.52,118.16-11.2,168h0Zm-132.72-223.44c-71.12,0-128.8,57.68-128.8,128.8s57.68,128.8,128.8,128.8,128.8-57.68,128.8-128.8-57.68-128.8-128.8-128.8h0Zm0,235.2c-58.8,0-106.4-47.6-106.4-106.4s47.6-106.4,106.4-106.4,106.4,47.6,106.4,106.4-47.6,106.4-106.4,106.4Z" />
    </svg>,
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 700 700">
      <path fill="#FFFFFF" d="m622.9,349.21c-.36-11.02-4.98-21.24-13.03-28.79l-231.65-217.13c-15.82-14.83-40.61-14.83-56.44,0l-70.27,65.86v-19.88c0-5.92-4.81-10.73-10.73-10.73h-72.07c-5.92,0-10.73,4.81-10.73,10.73v107.55l-67.85,63.59c-8.05,7.54-12.68,17.77-13.03,28.79-.36,11.02,3.61,21.53,11.17,29.58l1.21,1.29c15.56,16.59,41.72,17.43,58.32,1.88l12.89-12.09v188.28c0,22.75,18.52,41.27,41.27,41.27h54.47c22.75,0,41.27-18.51,41.27-41.27v-114.15c0-10.92,8.89-19.81,19.81-19.81h64.98c10.92,0,19.81,8.89,19.81,19.81v114.15c0,22.75,18.51,41.27,41.27,41.27h54.47c11,0,21.36-4.3,29.17-12.11,7.8-7.8,12.1-18.16,12.1-29.16v-188.28l12.89,12.08c7.55,7.07,17.37,11.02,27.71,11.14h.49c11.37,0,22.34-4.73,30.08-12.99l1.26-1.34c7.55-8.05,11.51-18.55,11.16-29.56ZM179.44,160.01h50.61v29.26l-50.61,47.44v-76.7Zm338.41,398.15c0,10.92-8.89,19.81-19.81,19.81h-54.47c-10.92,0-19.81-8.89-19.81-19.81v-114.15c0-22.75-18.51-41.26-41.27-41.26h-64.98c-22.76,0-41.27,18.51-41.27,41.26v114.15c0,10.92-8.89,19.81-19.81,19.81h-54.47c-10.92,0-19.81-8.89-19.81-19.81v-208.4l167.85-157.32,167.85,157.33v208.39Zm78.26-194.08l-1.26,1.34c-3.6,3.84-8.49,6.06-13.78,6.23-.22,0-.44.01-.66.01-5.05,0-9.83-1.89-13.53-5.35l-209.53-196.4c-1.99-1.87-4.6-2.9-7.34-2.9-2.73,0-5.34,1.03-7.34,2.9l-209.54,196.4c-7.95,7.46-20.51,7.05-27.99-.92l-1.21-1.29c-3.63-3.88-5.53-8.92-5.36-14.2.17-5.28,2.39-10.19,6.25-13.81l231.65-217.13c7.59-7.12,19.49-7.12,27.09,0l231.65,217.12c3.86,3.61,6.08,8.52,6.25,13.81.17,5.29-1.73,10.32-5.34,14.18Z" />
    </svg>,
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 700 700">
      <path fill="#FFFFFF" d="m508.31,336.13c-3.81-1.79-8.2-1.22-11.46,1.5l-141.32,119.5c-3.39,2.86-4.64,7.63-3.11,11.9,1.61,4.29,5.56,7.06,10.07,7.06h141.32c5.91,0,10.71-4.81,10.71-10.71v-119.6c0-4.14-2.44-7.93-6.21-9.65Zm-116.58,118.53l101.37-85.75v85.75h-101.37Z" />
      <path fill="#FFFFFF" d="m612.7,111.36c-10.79-4.96-23.48-3.23-32.32,4.39L80.88,538.5l-.31.26c-9.4,7.9-12.9,21.13-8.69,32.95,4.46,12,15.51,19.75,28.14,19.75h499.92c16.51,0,29.94-13.43,29.94-29.94V138.51c0-11.37-6.73-22.03-17.18-27.15Zm-51.21,429.83c-5.91,0-10.71,4.81-10.71,10.71v18.13h-36.26v-18.13c0-5.91-4.81-10.71-10.71-10.71s-10.71,4.81-10.71,10.71v18.13h-36.26v-18.13c0-5.91-4.81-10.71-10.71-10.71s-10.71,4.81-10.71,10.71v18.13h-36.26v-18.13c0-5.91-4.81-10.71-10.71-10.71s-10.71,4.81-10.71,10.71v18.13h-36.26v-18.13c0-5.91-4.81-10.71-10.71-10.71s-10.71,4.81-10.71,10.71v18.13h-36.26v-18.13c0-5.91-4.81-10.71-10.71-10.71s-10.71,4.81-10.71,10.71v18.13h-36.26v-18.13c0-5.91-4.81-10.71-10.71-10.71s-10.71,4.81-10.71,10.71v18.13h-36.26v-18.13c0-5.91-4.81-10.71-10.71-10.71s-10.71,4.81-10.71,10.71v18.13h-46.97c-3.59,0-6.74-2.25-8.01-5.72h0c-1.21-3.3-.23-6.98,2.47-9.17l499.96-423.05c1.46-1.38,3.36-2.1,5.49-2.1,1.28,0,2.48.26,3.56.76,3.01,1.46,4.96,4.5,4.96,7.76v423.01c0,4.7-3.82,8.52-8.52,8.52h-27.74v-18.13c0-5.91-4.81-10.71-10.71-10.71Z" />
    </svg>,
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 700 700">
      <path fill="#FFFFFF" d="m123.16,440.25h84.02l3.51,7.67c20.97,45.83,55.05,83.51,98.54,108.98,43.49,25.46,93.03,36.74,143.26,32.61,50.19-4.13,97.18-23.33,135.91-55.52,4.84-4.24,7.12-10.85,5.89-17.23-1.23-6.41-5.83-11.73-12-13.87-5.84-2.02-12.26-.98-17.17,2.79l-1.07.88c-37.55,31-84.67,47.69-132.78,47.69-10.25,0-20.53-.76-30.79-2.29-58.4-8.75-110.55-42.04-143.08-91.34l-13.43-20.36h188.13c6.33,0,12.22-3.4,15.38-8.88,3.16-5.48,3.16-12.29,0-17.76-3.16-5.48-9.06-8.88-15.38-8.88h-200.13l-2.5-9.92c-4.06-16.12-6.14-32.71-6.17-49.32l-.02-13.15h208.81c6.33,0,12.22-3.4,15.38-8.88,3.16-5.48,3.16-12.29,0-17.76-3.16-5.48-9.06-8.88-15.38-8.88h-203.58l5.77-17.29c19.26-57.69,62.58-104.02,118.84-127.13,56.26-23.1,119.64-20.58,173.88,6.91l.54.29c4.25,2.44,9.32,3.02,13.96,1.64,4.63-1.38,8.55-4.65,10.74-8.96,2.2-4.31,2.54-9.41.93-13.97-1.61-4.56-5.06-8.31-9.47-10.3l-.51-.25c-44.07-22.37-93.22-30.81-142.18-24.43-48.96,6.38-94.31,27.13-131.13,60-36.83,32.87-62.57,75.57-74.46,123.5l-2.47,9.97h-69.79c-6.33,0-12.22,3.4-15.39,8.88-3.16,5.48-3.16,12.29,0,17.77,3.16,5.48,9.06,8.88,15.39,8.88h64.56l.05,13.07c.06,14.66,1.44,29.4,4.1,43.8l2.87,15.51h-71.59c-6.33,0-12.22,3.4-15.39,8.88-3.16,5.48-3.16,12.29,0,17.77,3.16,5.47,9.06,8.88,15.39,8.88Z" />
    </svg>,
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 700 700">
      <path fill="#FFFFFF" d="m350,103.26c-136.06,0-246.75,110.69-246.75,246.75s110.69,246.75,246.75,246.75,246.75-110.69,246.75-246.75-110.69-246.75-246.75-246.75Zm0,458.81c-116.93,0-212.06-95.13-212.06-212.06s95.13-212.06,212.06-212.06,212.06,95.13,212.06,212.06-95.13,212.06-212.06,212.06Z" />
      <path fill="#FFFFFF" d="m335.37,359.05c.05.11.1.22.16.32l.25.35c.61.96,1.49,1.89,2.11,2.5l79.19,78.54c3.25,3.25,7.58,5.03,12.23,5.03s9.07-1.87,12.33-5.13c6.74-6.74,6.69-17.75-.11-24.55l-74.18-73.28v-102.81c0-9.56-7.78-17.35-17.35-17.35s-17.35,7.78-17.35,17.35v110c0,1.27.1,2.31.32,3.24l.03.16c.03.13.13.48.29.9l.16.45.13.47c.1.35.25.89.33,1.07l.11.23c.1.24.28.55.46.87.16.28.31.56.45.83.15.26.29.53.42.81Z" />
    </svg>,
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 700 700">
      <path fill="#FFFFFF" d="m371.16,365.05h181.08c4.62,0,8.86-2.5,11.09-6.54,2.24-4.05,2.09-9-.39-12.9l-54.36-85.87,54.36-85.84c2.48-3.9,2.62-8.85.39-12.9-2.23-4.04-6.48-6.54-11.09-6.54h-168.37v-19.53c0-3.39-1.33-6.57-3.74-8.96-2.39-2.38-5.57-3.69-8.94-3.69h-133.71v-13.26c-.01-3.38-1.34-6.55-3.74-8.93-2.39-2.37-5.56-3.67-8.92-3.67h-49.53c-6.93.02-12.59,5.68-12.62,12.61v469.38c-.02,7,5.64,12.7,12.62,12.73h49.52c3.39,0,6.57-1.32,8.97-3.71,2.37-2.37,3.72-5.66,3.71-9.01v-245.62h121.06v19.53c-.03,6.99,5.63,12.7,12.62,12.72Zm12.72-185.26h145.32l-46.47,73.33c-2.48,4.09-2.44,9.31.12,13.37l46.35,73.23h-145.32s0-159.92,0-159.92Zm-171.72,385.98h-24.14V121.75h24.14v444.02Zm146.39-258.34h-119.85s0-159.79,0-159.79h119.85s0,159.79,0,159.79Z" />
    </svg>
  ];

  // Handlers
  const buildRoofImage = async (latitude: number, longitude: number, polygon: google.maps.Polygon): Promise<Blob> => {
    // Maps Static API
    let url = "https://maps.googleapis.com/maps/api/staticmap?";

    const polygonPaths = polygon.getPaths().getArray()[0].getArray().map(({ lat, lng }) => (`${lat()},${lng()}`));

    // Parameters building
    // Center
    url += `center=${latitude},${longitude}`;
    // Zoom
    url += "&zoom=19";
    // Size
    url += "&size=300x300";
    // Maptype
    url += "&maptype=satellite";
    // Path
    url += `&path=weight:2|fillcolor:0x0000829A|${polygonPaths.join('|')}`;
    // API  key
    url += "&key=AIzaSyAkFJnVCG2aSok3Y3USuEs7DllYEjLKdvI";

    const res = await fetch(url);
    return await res.blob();

    // const blob = await blobToBase64(await res.blob());
    // return blob;
  }

  // Child Components
  // Slides
  const slides = [
    <AddressSlide
      text={formState.address.text}
      latitude={formState.address.latitude}
      longitude={formState.address.longitude}
      onAddressChange={(text, latitude, longitude) => {
        setFormState({
          ...formState,
          address: {
            ...formState.address,
            text,
            latitude,
            longitude
          }
        });
      }}
      onContinue={() => {
        if (!stepsConfirmations[0]) {
          // Buffers
          const stepsConfirmationsBuffer = stepsConfirmations;

          // Update buffer
          stepsConfirmationsBuffer[0] = true;

          // Update states
          setStepsConfirmations(stepsConfirmationsBuffer);
        }

        // Move step forward
        setStep(step + 1);
      }}
    />,
    <RoofAreaSlide
      latitude={formState.address.latitude}
      longitude={formState.address.longitude}
      roofArea={formState.roof.area.value}
      onRoofAreaChange={(value) => {
        setFormState({
          ...formState,
          roof: {
            ...formState.roof,
            area: {
              ...formState.roof.area,
              value
            }
          }
        });
      }}
      onContinue={(polygon) => {
        if (!stepsConfirmations[1]) {
          // Buffers
          const stepsConfirmationsBuffer = stepsConfirmations;

          // Update buffer
          stepsConfirmationsBuffer[1] = true;

          // Update states
          setStepsConfirmations(stepsConfirmationsBuffer);
        }

        // Move steps forward
        setRoofPolygon(polygon);
        setStep(step + 1);
      }}
    />,
    <RoofAngleOrientationSlide
      orientation={formState.roof.angleOrientation.orientation}
      inclination={formState.roof.angleOrientation.angle}
      onOrientationInclinationChange={(orientation, angle) => {
        setFormState({
          ...formState,
          roof: {
            ...formState.roof,
            angleOrientation: {
              ...formState.roof.angleOrientation,
              angle: angle!,
              orientation: orientation!
            }
          }
        });
      }}
      onContinue={() => {
        if (!stepsConfirmations[2]) {
          // Buffers
          const stepsConfirmationsBuffer = stepsConfirmations;

          // Update buffer
          stepsConfirmationsBuffer[2] = true;

          // Update states
          setStepsConfirmations(stepsConfirmationsBuffer);
        }

        // Move steps forward
        setStep(step + 1);
      }}
    />,
    <BillSlide
      consumption={formState.bill.consumption}
      onConsumptionChange={(consumption) => {
        setFormState({
          ...formState,
          bill: {
            ...formState.bill,
            consumption
          }
        });
      }}
      onFileChange={setBillFile}
      onContinue={() => {
        if (!stepsConfirmations[3]) {
          // Buffers
          const stepsConfirmationsBuffer = stepsConfirmations;

          // Update buffer
          stepsConfirmationsBuffer[3] = true;

          // Update states
          setStepsConfirmations(stepsConfirmationsBuffer);
        }

        // Move step forward
        setStep(step + 1);
      }}
    />,
    <ConsumptionHoursSlide
      consumptionHour={formState.hours.value}
      onConsumptionHourChange={(value) => {
        setFormState({
          ...formState,
          hours: {
            ...formState.hours,
            value
          }
        });
      }}
      onContinue={() => {
        if (!stepsConfirmations[4]) {
          // Buffers
          const stepsConfirmationsBuffer = stepsConfirmations;

          // Update buffer
          stepsConfirmationsBuffer[4] = true;

          // Update states
          setStepsConfirmations(stepsConfirmationsBuffer);
        }

        // Move step forward
        setStep(step + 1);
      }}
    />,
    <ContactSlide
      onSubmit={async (contact) => {
        try {
          // Roof image
          const roofImage = await buildRoofImage(formState.address.latitude, formState.address.longitude, roofPolygon!);

          // CCH Graph files
          const cchImage = await fetch(require(`./assets/${formState.hours.value}-cch.png`)).then(async (res) => await res.blob())
          const cchBase64Image = await blobToBase64(cchImage);

          // Build form data
          const body = new FormData();
          body.append('report_data.cch', formState.hours.value);
          body.append('report_data.consumption', `${formState.bill.consumption}`);
          body.append('report_data.customer_address', formState.address.text);
          body.append('report_data.customer_email', contact.email);
          body.append('report_data.customer_first_name', contact.name);
          body.append('report_data.customer_last_name', contact.lastName);
          body.append('report_data.customer_phone', contact.phone);
          body.append('report_data.latitude', `${formState.address.latitude}`);
          body.append('report_data.longitude', `${formState.address.longitude}`);
          body.append('report_data.roof_angle', `${formState.roof.angleOrientation.angle}`);
          body.append('report_data.roof_area', `${formState.roof.area.value}`);
          body.append('report_data.roof_orientation', formState.roof.angleOrientation.orientation);
          if (!!billFile) {
            body.append('report_data.bill', billFile);
          }
          body.append('report_image', cchBase64Image); // Base 64
          body.append('report_image2', roofImage, "roof-image"); // Blob
          body.append('portal_id', process.env.NODE_ENV === 'production' ? '7342304' : '27026822');
          body.append('form_id', process.env.NODE_ENV === 'production' ? 'a6944b20-9d0f-4585-a318-8b67aca874ed' : '60a16055-5c8b-4f2f-8e1a-378a159c485e');

          // Nuevos campos
          body.append("pipeline_id", "49996467"); // Id correspondiente a "Ampgy - Nuevo Panel de Ventas" (para el deal)
          body.append("dealstage", "Nuevo"); // Para el deal
          body.append("deal_name", "SIM. LITE -"); // Prefijo para el deal
          body.append("num_days_deal_active", "10"); // Días para la fecha de cierre desde "ahora" (para el deal)
          body.append("amount", "0"); // Para el deal
          body.append("ampgy", "true"); // Propiedad añadida petición SIDN
          body.append("owner_id", "451876281"); // Id correspondiente a "captacion@ampgy.com" (para el deal)


          // Call API
          const url = `${process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:5001/ampgy-form/us-central1/sendSimulationFormData' : 'https://us-central1-ampgy-form.cloudfunctions.net'}/sendSimulationFormData`;
          const res = await fetch(url, {
            method: "POST",
            body
          });

          if (res.status === 200) {
            // Success, redirect
            // setCompleted(true);
            window.location.href = "https://unete.ampgyenergia.com/gracias-por-contactarnos";
          }
        } catch (err) {
          console.log(err);
        }
      }}
    />
  ];

  // On first load
  useEffect(() => {
    if (!!window.google && !firstLoad) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          // User has given consent
          const url = `${mapsApiEndpoint}/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=${mapsApiKey}`;

          const res = await fetch(url);
          const matches = (await res.json()).results;

          const rooftopMatches = matches.filter(({ geometry }: any) => geometry.location_type === "ROOFTOP");
          const interpolatedMatches = matches.filter(({ geometry }: any) => geometry.location_type === "RANGE_INTERPOLATED");
          const geometricCenterMatches = matches.filter(({ geometry }: any) => geometry.location_type === "GEOMETRIC_CENTER");
          const approximateMatches = matches.filter(({ geometry }: any) => geometry.location_type === "APPROXIMATE");

          const mostAccurateResult = [...rooftopMatches, ...interpolatedMatches, ...geometricCenterMatches, ...approximateMatches][0];

          setFormState({
            ...formState,
            address: {
              text: mostAccurateResult.formatted_address,
              latitude: mostAccurateResult.geometry.location.lat,
              longitude: mostAccurateResult.geometry.location.lng
            }
          })
          setFirstLoad(true);
        },
        (error) => {
          // An error ocurred, continue (no consent)
          console.log(error);
          setFirstLoad(true);
        });
    }
  }, [window.google]);

  // Chevron
  const chevron = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path fill="#008198" d="M14 20c0.128 0 0.256-0.049 0.354-0.146 0.195-0.195 0.195-0.512 0-0.707l-8.646-8.646 8.646-8.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-9 9c-0.195 0.195-0.195 0.512 0 0.707l9 9c0.098 0.098 0.226 0.146 0.354 0.146z" />
  </svg>;

  return (
    <div className={`main-form${step >= 5 ? ' last-step' : ''}`}>
      <header className="main-form__header">
        <button
          className={`main-form__header--navigation previous ${step <= 0 ? 'hide' : ''}`}
          disabled={step <= 0}
          onClick={() => { setStep(step - 1) }}
        >
          {chevron}
          Atrás
        </button>
        <button
          className={`main-form__header--navigation next ${step >= 4 ? 'hide' : ''}`}
          disabled={!stepsConfirmations[step]}
          onClick={() => { setStep(step + 1) }}
        >
          Adelante
          {chevron}
        </button>
      </header>
      <main className="main-form__content">
        {
          slides.map((slide, i) =>
            <div key={`main-form__content--slide--${i}`} className={`main-form__content--slide${i === step ? ' show' : ''}${i < step ? ' previous' : ''}${i > step ? ' next' : ''}`}>
              {slide}
            </div>
          )
        }
      </main>
      <footer className={`main-form__footer ${step >= 5 ? 'hide' : ''}`}>
        {bottomNavigation.map(
          (icon, i) =>
            <Fragment key={`bottom-navigation--item--${i}`}>
              <button disabled={step < i} onClick={() => { setStep(i); }} className="main-form__footer--page">
                {icon}
              </button>
              {i < bottomNavigation.length - 1 && <hr className={`main-form__footer--page-separator${step < i ? ' disabled' : ''}`} />}
            </Fragment>
        )}
      </footer>

      {/* {completed && <div className="main-form__thank-you">
        <h2>¡Gracias!</h2> 
      </div>} */}
    </div>
  );
}

export default App;
